/*!
 * Bombka Wspomnień – countdown
 * Real per-visitor countdown. Start time is persisted in localStorage
 * (set before first paint in snippets/head-config.liquid), so refreshing
 * or navigating does not reset it. When it reaches zero the page switches
 * to the "expired" state and the discount is no longer shown or applied.
 */
(function () {
  'use strict';

  var BW = window.BW || {};
  var offer = BW.offer || {};
  var html = document.documentElement;
  var S = BW.strings || {};

  if (!offer.enabled || !offer.end) return;

  var lastText = '';
  var lastSr = -1;
  var timer = null;
  var expired = false;

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function remaining() { return Math.max(0, offer.end - Date.now()); }

  function format(ms) {
    var total = Math.ceil(ms / 1000);
    var m = Math.floor(total / 60);
    var s = total % 60;
    return pad(m) + ':' + pad(s);
  }

  function setDigits(text) {
    var chars = text.replace(':', '').split('');
    var nodes = document.querySelectorAll('[data-bw-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var digits = el.querySelectorAll('[data-bw-d]');
      for (var d = 0; d < digits.length; d++) {
        var pos = parseInt(digits[d].getAttribute('data-bw-d'), 10);
        var ch = chars[pos] || '0';
        if (digits[d].textContent !== ch) {
          digits[d].textContent = ch;
          digits[d].classList.remove('is-tick');
          // force reflow so the glow/flip animation restarts
          void digits[d].offsetWidth;
          digits[d].classList.add('is-tick');
        }
      }
    }
  }

  function setSr(ms) {
    // Update the screen-reader text once per minute only (not every second).
    var minute = Math.ceil(ms / 60000);
    if (minute === lastSr) return;
    lastSr = minute;
    var txt = (S.timeLeft || '').replace('__TIME__', format(ms));
    var nodes = document.querySelectorAll('[data-bw-countdown-sr]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = txt;
  }

  function expire() {
    if (expired) return;
    expired = true;
    html.classList.remove('bw-offer-active', 'bw-offer-final');
    html.classList.add('bw-offer-expired');
    setDigits('00:00');
    var nodes = document.querySelectorAll('[data-bw-countdown-sr]');
    for (var i = 0; i < nodes.length; i++) nodes[i].textContent = S.offerEnded || '';
    try { document.dispatchEvent(new CustomEvent('bw:offer-expired')); } catch (e) {}
    if (timer) clearTimeout(timer);
  }

  function tick() {
    var ms = remaining();
    if (ms <= 0) { expire(); return; }
    var text = format(ms);
    if (text !== lastText) {
      lastText = text;
      setDigits(text);
      setSr(ms);
      html.classList.toggle('bw-offer-final', ms <= 60000);
    }
    // align next tick with the next full second of the remaining time
    var delay = ms % 1000 || 1000;
    timer = setTimeout(tick, Math.min(delay + 15, 1000));
  }

  BW.offerActive = function () { return !expired && remaining() > 0; };
  window.BW = BW;

  if (remaining() <= 0) expire();
  else tick();

  // Re-sync after the tab returns from background (timers are throttled there).
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && !expired) {
      if (timer) clearTimeout(timer);
      lastText = '';
      tick();
    }
  });
})();
